<template>
  <div class="add-address" v-if="isShow">
    <div class="address-cn">
      <i class="el-icon-circle-close" @click="hide"></i>
      <h3 class="address-title">添加地址</h3>
      <el-form :model="ruleForm" ref="ruleForm">
        <div class="address-top">
          <el-form-item label="收货人" class="form-username fn-left">
            <el-input type="text" v-model="ruleForm.person" autocomplete="off" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号" class="form-phone fn-right">
            <el-input type="text" v-model="ruleForm.phone" autocomplete="off" clearable></el-input>
          </el-form-item>
        </div>
        <!-- <div class="address-list"> -->
        <el-form-item label="地址信息">
          <el-select v-model="ruleForm.province" value-key='code' @change="getCityList" style="width:150px" placeholder="请选择省">
            <el-option v-for="item in proList" :key="item.code" :label="item.name" :value="item"></el-option>
          </el-select>
          <el-select v-model="ruleForm.city" @change="getCountyList" value-key='id' style="width:150px;margin:0 5px" placeholder="请选择市">
            <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
          <el-select v-model="ruleForm.county" @change="county" value-key='id' style="width:150px" placeholder="请选择区">
            <el-option v-for="item in CountyList" :key="item.id" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <!-- </div> -->
        <el-form-item label="详细信息">
          <el-input v-model.number="ruleForm.fullAddress" clearable></el-input>
        </el-form-item>
      </el-form>
      <button @click="submit">确定</button>
      <button @click="hide" class="cancel">取消</button>
    </div>
  </div>
</template>
<script>
import { getAllProvince, addressGetCityByProvinceCode, addressGetCountyByCityId, saveUserAddress } from '@/api/crm'
export default {
  name: 'add-address',
  props: ['value'],
  data () {
    // 校验手机号
    var checkPhone = (rule, value, callback) => {
      const regPhone = /^1[3-9]\d{9}$/
      if (regPhone.test(value)) {
        return callback()
      } else {
        callback(new Error('请输入合法的手机号'))
      }
    }
    return {
      isShow: false,
      ruleForm: {
        city: '',
        cityId: null,
        county: '',
        countyId: null,
        fullAddress: '',
        person: '',
        phone: '',
        province: '',
        provinceCode: '',
        userId: localStorage.getItem('userId')
      },
      rules: {
        username: [
          {
            required: true,
            message: '请填写收货人姓名',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: true,
            message: '请填写手机号',
            trigger: 'blur'
          },
          {
            validator: checkPhone,
            trigger: 'blur'
          }
        ],
        prov: [{
          required: true,
          message: '请选择省',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          message: '请选择市',
          trigger: 'blur'
        }],
        district: [{
          required: true,
          message: '请选择区',
          trigger: 'blur'
        }],
        detail: [{
          required: true,
          message: '请填写详细地址',
          trigger: 'blur'
        }]
      },
      proList: [],
      cityList: [],
      CountyList: [],
      showType: '',
      addressIndex: ''
    }
  },
  created () {
    this.getAllPro()
  },
  methods: {
    show (type, item, index) {
      this.isShow = true
      this.showType = type
      this.addressIndex = ''
      if (type === 'add') {
        this.ruleForm.username = ''
        this.ruleForm.phone = ''
        this.ruleForm.prov = ''
        this.ruleForm.detail = ''
      }
      if (type === 'edit') {
        this.addressIndex = index
        let area = item.address.split(' ')
        this.ruleForm.username = item.username
        this.ruleForm.phone = item.phone
        this.ruleForm.prov = area[0].substr(0, area[0].length - 1)
        this.ruleForm.city = area[1].substr(0, area[1].length - 1)
        if (area.length >= 3) {
          this.ruleForm.district = area[2]
        }
        this.ruleForm.detail = item.detail
      }
    },
    hide () {
      this.isShow = false
    },
    submit () {
      saveUserAddress(this.ruleForm).then(res => {
        if (res.data.success) {
          this.$message.success('添加成功')
          this.$emit('addAddress')
          this.hide()
        }
      })
    },
    getAllPro () {
      getAllProvince().then(res => {
        if (res.data.success) {
          this.proList = res.data.data
        }
      })
    },
    getCityList (val) {
      this.ruleForm.province = val.name
      this.ruleForm.provinceCode = val.code
      addressGetCityByProvinceCode(val.code).then(res => {
        this.cityList = res.data.data
      })
    },
    getCountyList (val) {
      this.ruleForm.city = val.name
      this.ruleForm.cityId = val.id
      addressGetCountyByCityId(val.id).then(res => {
        this.CountyList = res.data.data
      })
    },
    county (val) {
      this.ruleForm.county = val.name
      this.ruleForm.countyId = val.id
    }
  }
}
</script>
<style scoped lang="less">
@deep: ~">>>";

.add-address {
  position: fixed;
  width: 100%;
  top: 15%;
  left: 0;
  z-index: 999;

  .address-cn {
    background: #fff;
    box-shadow: 0 3px 12px rgba(0, 0, 0, 0.34);
    width: 713px;
    height: 525px;
    border-radius: 8px;
    margin: 0 auto;
    padding: 22px 60px;
    box-sizing: border-box;

    i {
      float: right;
      font-size: 28px;
      overflow: hidden;
      height: 28px;
      cursor: pointer;
      color: #2a2a2a;
    }

    h3.address-title {
      font-size: 24px;
      line-height: 40px;
      padding: 20px 0;
      color: #2a2a2a;
      margin-top: 15px;
      border-bottom: 1px solid #e8e8e8;
      font-weight: normal;
    }

    button {
      width: 110px;
      height: 46px;
      border-radius: 30px;
      color: #fff;
      font-size: 18px;
      background: #2a2a2a;
      outline: none;
      border: none;
      box-shadow: none;
      float: right;
      margin-top: 20px;
      cursor: pointer;
      margin-left: 15px;

      &:hover {
        opacity: 0.6;
      }
    }

    .cancel {
      background: #707070;
    }

    .el-form {
      margin-top: 20px;

      .address-top {
        overflow: hidden;
      }
    }

    .el-form-item {
      clear: both;

      .el-address {
        border: none;
      }

      @{deep} .el-form-item__label {
        line-height: 30px;
      }

      @{deep} .el-input__inner {
        border-color: #6d6d6d;
      }

      .el-address {
        select {
          width: 120px;
          height: 40px;
          border: 1px solid #6d6d6d;
          padding: 0 10px;
          box-sizing: border-box;
          color: #666;
          margin-right: 10px;
          border-radius: 5px;
          outline: none;

          option {
            color: #666;
            line-height: 40px;
          }
        }
      }
    }

    .form-phone,
    .form-username {
      width: 45%;
      clear: none;
    }

    .address-list {
      .el-form-item {
        display: inline-block;
      }
    }
  }
}
</style>
